
export default {
  props: {
    post: {
      type: Object,
      default: () => ({}),
    },
    isGalleryPost: {
      type: Boolean,
      default: false,
    },
    images: {
      type: Array,
      default: () => [],
    },
    options: {
      type: Object,
      default: () => ({}),
    },
  },
  data () {
    return {
      activeIndex: 0, // Image showing in slider
      lightboxOpen: false,
      carouselOptions: {
        slidesPerView: `auto`,
        spaceBetween: 1,
      },
      carousel: null,
    };
  },
  computed: {
    sortedImages () {
      const galleryItems = this.isGalleryPost
        ? this.post.acf.gallery_items
        : this.images;
      if (galleryItems) {
        return [...galleryItems].map(image => ({
          src: image.url,
          thumbnail: image.sizes.large,
          alt: image.alt,
          title: image.title,
          caption: image.caption,
          w: 0,
          h: 0,
        }));
      }
      return [];
    },
    sliderName () {
      return `gallery-${Math.floor(Math.random() * 1000)}`;
    },
    progressWidth () {
      return this.sortedImages.length
        ? `${((this.activeIndex + 1) / this.sortedImages.length) * 100}%`
        : 0;
    },
    activeImage () {
      return this.sortedImages.length
        ? this.sortedImages[this.activeIndex]
        : null;
    },
    canNext () {
      return this.activeIndex < this.sortedImages.length - 1;
    },
    canPrev () {
      return this.activeIndex > 0;
    },
  },
  methods: {
    nextSlide () {
      this.carousel.slideNext(500);
    },
    prevSlide () {
      this.carousel.slidePrev(500);
    },
    slideChange (index) {
      this.activeIndex = index;
    },
    openLightbox (index) {
      this.activeIndex = index;
      this.lightboxOpen = true;
    },
  },
};
